import axiosInstance from './AxiosInstance';

export function getSupportRequests(currentPage, pageSize, searchTerm, filterQuery) {
  return axiosInstance.get('/support', {
    params: {
      page: currentPage,
      pageSize,
      search: searchTerm,
      ...filterQuery
    }
  });
}
